import * as CryptoJS from "crypto-js";
import Cookies from "js-cookie";

const setToken = async (token) => {
    Cookies.set("_token", CryptoJS.AES.encrypt(token.toString(), import.meta.env.VITE_APP_SECRET).toString(), {secure: true, expires : 1, sameSite: "strict", path : "/"});
};

const setRefreshToken = async (refreshToken) => {
    Cookies.set("_refresh_token", CryptoJS.AES.encrypt(refreshToken.toString(), import.meta.env.VITE_APP_SECRET).toString(), {secure: true, expires : 1, sameSite: "strict", path : "/"});
};

const setCurrentUser = async (user) => {
    Cookies.set("_current_user", CryptoJS.AES.encrypt(user.toString(), import.meta.env.VITE_APP_SECRET).toString(), {secure: true, expires : 1, sameSite: "strict", path : "/"});
};

const getToken = () => {
    let value = null;
    if (Cookies.get("_token")) {
        value = CryptoJS.AES.decrypt(Cookies.get("_token"), import.meta.env.VITE_APP_SECRET).toString(CryptoJS.enc.Utf8);
    }
    return value;
};

const getRefreshToken = () => {
    let value = null;
    if (Cookies.get("_refresh_token")) {
        value = CryptoJS.AES.decrypt(Cookies.get("_refresh_token"), import.meta.env.VITE_APP_SECRET).toString(CryptoJS.enc.Utf8);
    }
    return value;
};
/**
 * Retrieves and decrypts the current user data stored in cookies.
 *
 * @returns {{
 *   token: string,
 *   user_id: number,
 *   email: string,
 *   lastname: string,
 *   name: string,
 *   ip: string,
 *   is_client: boolean,
 *   roles: string[],
 *   trainings: object[],
 *   situation_pro: string,
 *   family_situation: string,
 *   refresh_token: string
 * }} The decrypted user data object.
 */
const getCurrentUser = () => {
    let value = null;
    if (Cookies.get("_current_user")) {
        value = CryptoJS.AES.decrypt(Cookies.get("_current_user"), import.meta.env.VITE_APP_SECRET).toString(CryptoJS.enc.Utf8);
    }
    return JSON.parse(value);
};

const encryptData = (data) => {
    const jsonString = JSON.stringify(data);
    const base64Data = btoa(jsonString);

    const signature = CryptoJS.HmacSHA256(base64Data, import.meta.env.VITE_CRYPT_SECRET).toString(CryptoJS.enc.Base64);

    return `${base64Data}.${signature}`;
};

const decryptData = (encodedData) => {
    const [base64Data, providedSignature] = encodedData.split(".");
    const calculatedSignature = CryptoJS.HmacSHA256(base64Data, import.meta.env.VITE_CRYPT_SECRET).toString(CryptoJS.enc.Base64);

    if (calculatedSignature !== providedSignature) {
        console.error("Invalid signature");
        return null;
    }

    return JSON.parse(atob(base64Data));
};

const logOut = () => {
    Cookies.remove("_token");
    Cookies.remove("_refresh_token");
    Cookies.remove("_current_user");
};

export { setToken, setRefreshToken, setCurrentUser, getToken, getRefreshToken, getCurrentUser, logOut, encryptData, decryptData };
